import PropTypes from "prop-types";
import { ScaleContainer, ScaleLine } from "./Scale.styles";

const Scale = ({ show, divisions, ...props }) => {
    return (
        <ScaleContainer show={show} className={props.className}>
            {Array.from(new Array(divisions), (_e, i) => {
                return <ScaleLine key={i} />;
            })}
        </ScaleContainer>
    );
};

Scale.propTypes = {
    show: PropTypes.bool,
    divisions: PropTypes.number,
    className: PropTypes.string,
};

Scale.defaultProps = {
    show: false,
    divisions: 3,
};

export default Scale;
